
import Vue, { PropType } from 'vue';
import { DataTableHeader } from 'vuetify';
import * as Config from '@/config';
export interface TypeItem {
  title: string;
}
export interface DataType {
  configData: any;
  search: any;
  searchText: any;
  selected: any;
}
export default Vue.extend({
  name: 'ManagementStationListDialog',
  components: {
    //
  },
  watch: {
    isShow(val) {
      if (val) {
        this.resData.forEach((element: any, key: any) => {
          if (element.code === this.office_code) {
            this.selected.push(element);
          }
        });
      }
    },
  },
  props: {
    resData: {
      default: () => [],
    },
    isShow: {
      type: Boolean,
      default: false,
    },
    office_code: {
      type: String,
      default: '',
    },
  },
  data: (): DataType => ({
    configData: Config,
    search: '',
    searchText: '',
    selected: [],
  }),
  mounted() {
    //
  },
  methods: {
    clickSearch() {
      this.search = this.searchText;
    },
  },
  computed: {
    headers: {
      get(): DataTableHeader[] {
        const headers: DataTableHeader[] = [
          {
            text: this.configData.TEXT_OFFICE_CODE,
            align: 'start',
            sortable: true,
            value: 'code',
          },
          {
            text: this.configData.TEXT_OFFICE_NAME,
            align: 'start',
            sortable: true,
            value: 'name',
          },
        ];
        return headers;
      },
      set(): void {
        return;
      },
    },
  },
});
